import { chunkListings } from './marketplaceModel'

function errorMessage(error) {
    return error?.error?.message || error?.data?.message || error?.reason || error?.message || String(error)
}

function isUserRejected(error) {
    const code = error?.code ?? error?.error?.code
    const message = errorMessage(error).toLowerCase()
    return Number(code) === 4001 || message.includes('user rejected') || message.includes('user denied')
}

export async function executeListingBatches({
    listings,
    submitBatch,
    submitSingle,
    onProgress = () => {},
}) {
    const batches = chunkListings(listings)
    const successfulTokenIds = []
    const transactionHashes = []
    const failed = []

    const rememberTransaction = (receipt) => {
        const hash = receipt?.transactionHash || receipt?.hash
        if (hash) transactionHashes.push(hash)
    }

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex += 1) {
        const batch = batches[batchIndex]
        onProgress({ phase: 'batch-submitting', batchIndex, batchCount: batches.length, size: batch.length })
        try {
            const receipt = await submitBatch(batch, batchIndex)
            successfulTokenIds.push(...batch.map((item) => item.tokenId))
            rememberTransaction(receipt)
            onProgress({ phase: 'batch-success', batchIndex, batchCount: batches.length, size: batch.length, receipt })
            continue
        } catch (error) {
            if (isUserRejected(error)) throw error
            onProgress({ phase: 'batch-failed', batchIndex, batchCount: batches.length, size: batch.length, reason: errorMessage(error) })
        }

        for (let itemIndex = 0; itemIndex < batch.length; itemIndex += 1) {
            const listing = batch[itemIndex]
            onProgress({ phase: 'single-submitting', batchIndex, itemIndex, tokenId: listing.tokenId })
            try {
                const receipt = await submitSingle(listing, batchIndex, itemIndex)
                successfulTokenIds.push(listing.tokenId)
                rememberTransaction(receipt)
                onProgress({ phase: 'single-success', batchIndex, itemIndex, tokenId: listing.tokenId, receipt })
            } catch (error) {
                const reason = errorMessage(error)
                failed.push({ tokenId: listing.tokenId, reason })
                onProgress({ phase: 'single-failed', batchIndex, itemIndex, tokenId: listing.tokenId, reason })
            }
        }
    }

    return { successfulTokenIds, transactionHashes, failed }
}

export { errorMessage, isUserRejected }
